import { useId } from "react";

export const WAVE_FRONT = "M8 41 c 5.33 4, 10.67 4, 16 0 c 5.33 -4, 10.67 -4, 16 0 c 5.33 4, 10.67 4, 16 0";
export const WAVE_BACK = "M8 53 c 5.33 4, 10.67 4, 16 0 c 5.33 -4, 10.67 -4, 16 0 c 5.33 4, 10.67 4, 16 0";

// The mark: the sun dipping behind the first of two swells (brand/README.md). The strokes take the
// text colour, so it follows Daylight and Night; the dip is a mask, so it sits on any background.
export function Mark({ className = "tm-mark" }: { className?: string }) {
  const mask = useId();
  return (
    <svg className={className} viewBox="0 0 64 64" aria-hidden="true">
      <defs>
        <mask id={mask}>
          <rect width="64" height="64" fill="#fff" />
          <path d={WAVE_FRONT} fill="none" stroke="#000" strokeWidth="12.5" strokeLinecap="round" />
        </mask>
      </defs>
      <circle cx="37" cy="30" r="14.5" fill="var(--sun)" mask={`url(#${mask})`} />
      <path d={WAVE_FRONT} fill="none" stroke="currentColor" strokeWidth="6" strokeLinecap="round" />
      <path d={WAVE_BACK} fill="none" stroke="currentColor" strokeWidth="6" strokeLinecap="round" />
    </svg>
  );
}
